export default {
  SET_SEOMETA(state, payload) {
    state.seoMeta = payload;
  },
};
